// For ML Redirection
export const getMLAppUrl = () => `${window.env.REACT_APP_ML_REDIRECT_URL}/TemplateList`;

let app2Window = null;

export const openMLAppWindow = () => {
  if (!app2Window || app2Window.closed) {
    app2Window = window.open(getMLAppUrl(), "_blank");
  }
  return app2Window;
};

export const getMLAppWindow = () => app2Window;

export const setMLAppWindow = (win) => {
  app2Window = win;
};
